/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
import Flowit from '.';

const install = (Vue) => {
  Vue.prototype.$flowit = Flowit;
  Vue.prototype.$theme = {
    baseColor: 'rgb(26, 35, 126)',
    logo: 'logo',
  };
};

export default install;
